import { Component } from '@angular/core';

@Component({
  selector: 'orgbrain-test-result',
  templateUrl: './test-result.component.html',
  styleUrls: ['./test-result.component.scss'],
    standalone: false
})
export class TestResultComponent {}
